import React, { Fragment, useEffect, useState } from 'react';
import mixpanel from 'mixpanel-browser';

// Icons - material UI
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const MyActivity_Settings = ({
    auth,
    chat,
    notification,
    handleSlideMenu,
    getUnreadChats,
    getUnreadCount,
    history
}) => {

    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Screen Width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Notification Badge
    const [badgeValue, setBadgeValue] = useState(0);

    const hostname = window.location.hostname;

    // Listen for window resize event and update window width state
    useEffect(() => {

        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Clean up by removing event listener on component unmount
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    
    // Update badge value when notification or user change
    useEffect(() => {
        if(auth.user){
            getUnreadCount(auth.user._id);
            getUnreadChats(auth.user._id);
        }

    }, [notification.notifications, auth.user]);

    useEffect(() => {

        // Update badge value based on notification and chat counts
        setBadgeValue(notification.num_unread + chat.num_unread_chats);

    }, [notification.num_unread, chat.num_unread_chats])

    // Go back to main settings page
    const goBack = () => {
        window.location.href = '/settings';
    }

    // Determine mobile and tablet screen sizes
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    // Initialize Mixpanel and track settings account page view
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);
        mixpanel.track("Settings Activity Page View");
    }

    // Check if the code is running in production and Mixpanel event hasn't been sent yet
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {

        // Initialize Mixpanel and track the event
        handleMixpanel();

        // Set the flag to indicate that Mixpanel event has been sent
        setSentMixpanel(true);
    }

    return (
        <div className="settings">

            {/* Settings Header */}
            <div className="settings__header">
                {isTablet && (

                    // Back Button & Badge Value
                    <div onClick={goBack} className="profile__btnContainer">
                        <ArrowBackIcon />
                        {isMobile && badgeValue > 0 ? (
                            <span className="feed-header-badge defaultBadge">
                                {badgeValue}
                            </span>
                        ) : null}
                    </div>
                )}

                {/* Title */}
                <div onClick={handleSlideMenu} className="settings__headerText">
                    <h3>
                        My Activity
                    </h3>
                </div>
            </div>

            <div className="settings__body">
                <a style={{textDecoration:'none'}} href="/saved">
                    <div className="settings__item">
                        <div>
                            <div style={{fontSize:'15px', fontWeight:'500', lineHeight:'20px', overflowWrap:'break-word'}}>
                                <span>Saved</span>
                            </div>
                        </div>
                        <ChevronRightIcon />
                    </div>
                </a>
                <a style={{textDecoration:'none'}} href="/comments">
                    <div className="settings__item">
                        <div>
                            <div style={{fontSize:'15px', fontWeight:'500', lineHeight:'20px', overflowWrap:'break-word'}}>
                                <span>Comments</span>
                            </div>
                        </div>
                        <ChevronRightIcon />
                    </div>
                </a>
                <a style={{textDecoration:'none'}} href="/my-reviews">
                    <div className="settings__item">
                        <div>
                            <div style={{fontSize:'15px', fontWeight:'500', lineHeight:'20px', overflowWrap:'break-word'}}>
                                <span>Reviews</span>
                            </div>
                        </div>
                        <ChevronRightIcon />
                    </div>
                </a>
            </div>
        </div>
    )
}

export default MyActivity_Settings;
